import Randomizer from "../../../../src/docs/components/randomizer";
import ClientRandomizer from "../../../../src/docs/components/clientrandomizer";
import MillsCard from "../../../../src/docs/components/millscard";
import Brosvik from "../../../../src/docs/assets/brosvik.jpg";
import Greef from "../../../../src/docs/assets/greeff.jpg";
import * as React from 'react';
export default {
  Randomizer,
  ClientRandomizer,
  MillsCard,
  Brosvik,
  Greef,
  React
};